






































































































import { Vue, Component, Prop } from "vue-property-decorator"
import Article from "@/components/Article.vue"
import Versions from "@/components/Versions.vue"
import PcPreview from "@/components/Preview/PcPreview.vue"
import SpPreview from "@/components/Preview/SpPreview.vue"
import ThirdPartyCheck from "@/components/Preview/ThirdPartyCheck.vue"
import Postscript from "@/components/Postscript/Postscript.vue"
import ErrorMessages from "@/components/ErrorMessages.vue"
import api from "../honcierge-api"
import { AxiosError } from "axios"
import Loading from "@/components/Loading.vue"
import { PopupHtml, Postscript as PostscriptType } from "types/index"

@Component({
  components: {
    Article,
    PcPreview,
    SpPreview,
    ThirdPartyCheck,
    Versions,
    Postscript,
    ErrorMessages,
    Loading,
  },
})
export default class Tab extends Vue {
  @Prop()
  private articleId?: number

  private currentTabComponent = "Article"
  private postscripts: PostscriptType["data"][] = []
  private popupHTML: Record<number, string> = {}
  private isPreviewLoading = false
  private errorMessages: string[] = []

  public componentSelect(event: Event): void {
    const text = (event.currentTarget as InstanceType<typeof HTMLElement>)
      .innerText
    if (text === "編集") {
      this.currentTabComponent = "Article"
    } else if (text === "PCプレビュー") {
      const target = "PcPreview"
      this.setLoading(target)
      this.currentTabComponent = target
    } else if (text === "SPプレビュー") {
      const target = "SpPreview"
      this.setLoading(target)
      this.currentTabComponent = target
    } else if (text === "第三者チェック") {
      const target = "ThirdPartyCheck"
      this.setLoading(target)
      this.currentTabComponent = target
    } else if (text === "校正") {
      this.currentTabComponent = "Postscript"
    } else if (text === "更新履歴") {
      this.currentTabComponent = "Versions"
    }
  }

  private setLoading(tabComponentName: string) {
    if (
      tabComponentName === "PcPreview" ||
      tabComponentName === "SpPreview" ||
      tabComponentName === "ThirdPartyCheck"
    ) {
      this.isPreviewLoading = this.currentTabComponent !== tabComponentName // すでにタブが指定されている場合はローディングを出さない
      this.errorMessages = []
    }
  }

  private finishPreview(messages?: string[]) {
    this.isPreviewLoading = false
    if (messages) {
      this.errorMessages = messages
    }
  }

  private created() {
    api
      .getPopupHTML()
      .then((response) => {
        this.popupHTML = response.data.postscripts.reduce(
          (acc: Record<number, string>, postscript: PopupHtml["data"]) => {
            acc[postscript.id] = postscript.buildHtml
            return acc
          },
          {}
        )
      })
      .catch((error: AxiosError) => {
        this.$toasted.error("校正マスタの取得に失敗しました")
        console.log(error.stack)
      })

    api
      .getPostscripts()
      .then((response) => {
        this.postscripts = response.data.postscripts
      })
      .catch((error: AxiosError) => {
        this.$toasted.error("校正マスタの取得に失敗しました")
        console.log(error.stack)
      })
  }
}
